import Vue from 'vue'
import { sprintf } from 'sprintf-js'

Vue.use({
  install (Vue, options) {
    Vue.prototype.$c = function (msgid, formatting) {
      if (!this.$store.getters.currentPageContent) return sprintf(msgid, formatting)
      if (!this.$store.getters.currentPageContent[msgid]) return sprintf(msgid, formatting)
      return sprintf(this.$store.getters.currentPageContent[msgid], formatting)
    }
  }
})
